module.exports = __webpack_public_path__ + "static/media/diversified-icon.bc132523.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/diversified-icon.png
// module id = 92
// module chunks = 0